<!--=============================
=            FOOTERS            =
==============================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Footers</div>
      </base-header>
    </v-row>
    <v-row>
      <template>
        <v-col dark class="mt-2" cols="12">
          <strong class="white--text">Category </strong>
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <base-card>
            <div slot="card-header">

              title
            </div>
            <div slot="card-body">
              <div style="height:250px"></div>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="3" sm="12">
          <base-card>
            <div slot="card-header">

              title
            </div>
            <div slot="card-body">
              <div style="height:250px"></div>
            </div>
          </base-card>
        </v-col>
        <v-col cols="12" md="3" sm="12">
          <base-card>
            <div slot="card-header">

              title
            </div>
            <div slot="card-body">
              <div style="height:250px"></div>
            </div>
          </base-card>
        </v-col>

      </template>
    </v-row>
    <v-row>
      <template>
        <v-col dark class="mt-2" cols="12">
          <strong class="white--text">Category </strong>
        </v-col>

        <v-col cols="6" md="2">
          <v-card class="rounded-lg" height="150"></v-card>
        </v-col>
        <v-col cols="6" md="2">
          <v-card class="rounded-lg" height="150"></v-card>
        </v-col>
        <v-col cols="6" md="2">
          <v-card class="rounded-lg" height="150"></v-card>
        </v-col>
        <v-col cols="6" md="2">
          <v-card class="rounded-lg" height="150"></v-card>
        </v-col>
        <v-col cols="6" md="2">
          <v-card class="rounded-lg" height="150"></v-card>
        </v-col>
        <v-col cols="6" md="2">
          <v-card class="rounded-lg" height="150"></v-card>
        </v-col>
      </template>
    </v-row>
    <v-row>
      <template>
        <v-col dark class="mt-2" cols="12">
          <strong class="white--text">Category </strong>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="rounded-lg" height="150"></v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="rounded-lg" height="150"></v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card class="rounded-lg" height="150"></v-card>
        </v-col>
      </template>
    </v-row>
   
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    
  }
</script>


<!--====  End of FOOTERS  ====-->
